import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { safeLS } from "@/lib/safeStorage";

/* Sección numerada (tarjeta). Se pliega con la flecha de la derecha y recuerda si quedó cerrada.
   Al plegar, el contenido sigue montado: no se pierde lo que se estaba cargando. */
export function SectionCard({ id, num, title, description, children, action, testid }) {
  const nombre = typeof title === "string" ? title : "la sección";
  const clave = `tm_plegado_${id || testid || nombre}`;
  const [abierta, setAbierta] = useState(() => safeLS.getItem(clave) !== "1");
  const alternar = () => {
    const nueva = !abierta;
    setAbierta(nueva);
    if (nueva) safeLS.removeItem(clave); else safeLS.setItem(clave, "1");
  };
  return (
    <section
      id={id}
      data-testid={testid}
      className="tm-seccion bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden scroll-mt-24"
    >
      <div className={"tm-seccion-cab flex flex-wrap items-start justify-between gap-3 px-5 sm:px-6 py-4 " + (abierta ? "border-b border-slate-100" : "")}>
        <div className="flex items-start gap-3 min-w-0">
          <div className="tm-seccion-num h-8 w-8 shrink-0 rounded-lg bg-emerald-700 text-white flex items-center justify-center font-heading font-bold text-sm">
            {num}
          </div>
          <div className="min-w-0">
            <h3 className="font-heading text-lg font-bold text-emerald-950 leading-tight">
              {title}
            </h3>
            {description && (
              <p className="text-xs text-slate-500 mt-0.5 max-w-2xl">{description}</p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {action}
          <button type="button" onClick={alternar} aria-expanded={abierta} aria-label={abierta ? `Plegar ${nombre}` : `Abrir ${nombre}`}
            title={abierta ? "Plegar" : "Abrir"} className="tm-seccion-plegar">
            <ChevronDown className="h-5 w-5" />
          </button>
        </div>
      </div>
      <div className="tm-plegable" data-cerrado={abierta ? "false" : "true"}>
        <div><div className="p-4 sm:p-5">{children}</div></div>
      </div>
    </section>
  );
}
